<template>
  <div>
    <i v-if="loading" class="fa fa-cog fa-spin" style="font-size: 50px"></i>

    <section v-if="!loading" class="forms">
      <div class="page-header">
        <h3 class="page-title">{{ traeger.name }}</h3>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'traeger' }">Träger</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Detail</li>
          </ol>
        </nav>
      </div>

      <div class="row">
        <div class="col-md-12 stretch-card grid-margin">
          <div class="card">
            <div class="card-body">
              <b-tabs>
                <!-- (a) Stammdaten -->
                <b-tab title="Stammdaten" active>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Stammdaten</h4>
                      <form class="forms-sample">
                        <b-form-group label="Kindy-ID" label-for="inputKindyId">
                          <b-form-input v-model="traeger.kindy_id" type="text" id="inputKindyId" disabled></b-form-input>
                          <small class="text-muted">Kann nach der Anlage nicht mehr geändert werden.</small>
                        </b-form-group>
                        <b-form-group label="Name" label-for="inputName">
                          <b-form-input v-model="traeger.name" type="text" id="inputName" placeholder="Trägername"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Straße" label-for="inputStreet">
                          <b-form-input v-model="traeger.street" type="text" id="inputStreet" placeholder="Straße"></b-form-input>
                        </b-form-group>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group label="PLZ" label-for="inputZip">
                              <b-form-input v-model="traeger.zip" type="text" id="inputZip" placeholder="PLZ"></b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col-md-8">
                            <b-form-group label="Ort" label-for="inputCity">
                              <b-form-input v-model="traeger.city" type="text" id="inputCity" placeholder="Ort"></b-form-input>
                            </b-form-group>
                          </div>
                        </div>
                        <b-form-group label="Kontakt-E-Mail" label-for="inputEmail">
                          <b-form-input v-model="traeger.email" type="email" id="inputEmail" placeholder="E-Mail"></b-form-input>
                        </b-form-group>
                        <div style="text-align: right">
                          <b-button v-if="!saving_base" @click="btnSaveBase($event)" type="submit" variant="success" class="mr-2">Speichern</b-button>
                        </div>
                      </form>
                    </div>
                  </div>
                </b-tab>

                <!-- (b) Kita-Zuordnung -->
                <b-tab :title="'Kitas (' + assignedLocations.length + ')'">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Zugeordnete Kitas</h4>

                      <div class="assign-row">
                        <div class="assign-picker" ref="picker">
                          <div class="picker-input-wrap">
                            <i class="mdi mdi-magnify picker-icon"></i>
                            <input
                              type="text"
                              class="form-control picker-input"
                              v-model="locationSearch"
                              placeholder="Kita suchen (Name, Kindy-ID, Adresse oder Kategorie) ..."
                              autocomplete="off"
                              @focus="openPicker()"
                              @input="onSearchInput()"
                              @keydown.down.prevent="moveHighlight(1)"
                              @keydown.up.prevent="moveHighlight(-1)"
                              @keydown.enter.prevent="chooseHighlighted()"
                              @keydown.esc="closePicker()"
                            />
                            <button v-if="locationSearch || selectedLocationUid" type="button" class="picker-clear" title="Auswahl löschen" @click="clearSelection()">
                              <i class="mdi mdi-close"></i>
                            </button>
                          </div>

                          <div v-if="pickerOpen" class="picker-panel">
                            <div class="picker-meta">
                              <span>{{ filteredLocations.length }} von {{ pickableLocations.length }} Kitas</span>
                              <label class="picker-toggle">
                                <input type="checkbox" v-model="onlyFree" /> Nur Kitas ohne Träger
                              </label>
                            </div>
                            <ul class="picker-list">
                              <li
                                v-for="(loc, idx) in visibleLocations"
                                :key="loc.uid"
                                :class="['picker-item', idx === highlightIndex ? 'is-active' : '']"
                                @mousedown.prevent="choose(loc)"
                                @mouseenter="highlightIndex = idx"
                              >
                                <div class="picker-item-main">
                                  <span class="picker-item-name">{{ loc.name }}</span>
                                  <span v-if="loc.kindy_id" class="picker-item-id">{{ loc.kindy_id }}</span>
                                  <span v-if="loc.category" class="picker-item-cat">{{ loc.category }}</span>
                                </div>
                                <div v-if="loc.address || loc.foreign_department" class="picker-item-sub">
                                  <span v-if="loc.address">{{ loc.address }}</span>
                                  <span v-if="loc.foreign_department" class="picker-item-owner">aktuell: {{ loc.current_department_name || "anderer Träger" }}</span>
                                </div>
                              </li>
                              <li v-if="filteredLocations.length === 0" class="picker-empty">Keine Kita gefunden.</li>
                              <li v-else-if="filteredLocations.length > visibleLocations.length" class="picker-more">
                                {{ filteredLocations.length - visibleLocations.length }} weitere Treffer. Suche verfeinern.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <b-button variant="success" :disabled="!selectedLocationUid || assigning" @click="assign()">Zuordnen</b-button>
                      </div>

                      <div v-if="selectedLocation" class="assign-selected">
                        Ausgewählt: <strong>{{ selectedLocation.name }}</strong>
                        <span v-if="selectedLocation.kindy_id" class="assign-selected-id">{{ selectedLocation.kindy_id }}</span>
                        <span v-if="selectedLocation.category" class="assign-selected-cat">{{ selectedLocation.category }}</span>
                        <span v-if="selectedLocation.foreign_department" class="assign-selected-warn">
                          ist aktuell {{ selectedLocation.current_department_name || "einem anderen Träger" }} zugeordnet. Beim Zuordnen wird nachgefragt.
                        </span>
                      </div>

                      <div class="table-responsive mt-3">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>Kita</th>
                              <th>Kategorie</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="loc in assignedLocations" :key="loc.location_uid || loc.uid">
                              <td>{{ loc.name }}</td>
                              <td>{{ loc.category || "–" }}</td>
                              <td style="text-align: right">
                                <b-button size="sm" variant="outline-danger" @click="unassign(loc)">Entfernen</b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div v-if="assignedLocations.length === 0" class="empty-state">
                          <p>Noch keine Kita zugeordnet.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <!-- (c) Zugänge -->
                <b-tab :title="'Zugänge (' + users.length + ')'">
                  <div class="card">
                    <div class="card-body">
                      <div class="header-row">
                        <h4 class="card-title">Zugänge</h4>
                        <b-button variant="success" @click="openInvite">Zugang hinzufügen</b-button>
                      </div>

                      <div class="table-responsive mt-3">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>E-Mail</th>
                              <th>Zugriff</th>
                              <th>Status</th>
                              <th>Zuletzt angemeldet</th>
                              <th>Zuletzt aktiv</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="user in users" :key="user.uid">
                              <td>{{ user.name }}</td>
                              <td>{{ user.email }}</td>
                              <td>
                                <span class="badge preset-badge">{{ presetLabel(user.preset) }}</span>
                                <template v-if="userPreset(user) === 'custom'">
                                  <span v-for="key in (user.bereiche || [])" :key="key" class="bereich-chip">{{ bereichLabel(key) }}</span>
                                  <span v-if="!(user.bereiche || []).length" class="bereich-chip bereich-chip-empty">Keine Bereiche</span>
                                </template>
                              </td>
                              <td>
                                <span class="badge" :class="statusClass(user)">{{ statusLabel(user) }}</span>
                              </td>
                              <td>
                                <span v-if="formatUserActivity(user.last_login_at)">{{ formatUserActivity(user.last_login_at) }}</span>
                                <span v-else class="text-muted">Noch keine Anmeldung erfasst</span>
                              </td>
                              <td>
                                <span v-if="formatUserActivity(user.last_active_at)">{{ formatUserActivity(user.last_active_at) }}</span>
                                <span v-else class="text-muted">Noch keine Anmeldung erfasst</span>
                              </td>
                              <td style="text-align: right">
                                <b-button size="sm" variant="outline-secondary" class="mr-1" @click="openEditAccess(user)">Zugriff bearbeiten</b-button>
                                <b-button size="sm" variant="outline-primary" class="mr-1" @click="resetUserAccess(user)">Reset</b-button>
                                <b-button size="sm" variant="outline-danger" @click="deactivate(user)">Deaktivieren</b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div v-if="users.length === 0" class="empty-state">
                          <p>Noch keine Zugänge.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Einladen-Dialog: Zugang hinzufügen -->
    <b-modal id="modalInviteUser" title="Zugang hinzufügen" size="md" @ok="submitInvite" @hidden="resetInvite"
      ok-title="Einladen" cancel-title="Abbrechen" :ok-disabled="inviting">
      <form class="forms-sample" @submit.prevent>
        <b-form-group label="Name" label-for="inviteName">
          <b-form-input v-model="inviteForm.name" type="text" id="inviteName" placeholder="Name"></b-form-input>
        </b-form-group>
        <b-form-group label="E-Mail" label-for="inviteEmail">
          <b-form-input v-model="inviteForm.email" type="email" id="inviteEmail" placeholder="E-Mail"></b-form-input>
        </b-form-group>
        <b-form-group label="Rolle / Zugriff" label-for="invitePreset">
          <b-form-select v-model="inviteForm.preset" :options="presetOptions" id="invitePreset"></b-form-select>
        </b-form-group>
        <b-form-group v-if="inviteForm.preset === 'custom'" label="Freigeschaltete Bereiche">
          <b-form-checkbox-group v-model="inviteForm.bereiche" :options="bereicheOptions" stacked></b-form-checkbox-group>
          <small class="text-muted">Controlling/Übersicht und Anwesenheit sind immer verfügbar.</small>
        </b-form-group>
      </form>
    </b-modal>

    <!-- Zugriff bearbeiten -->
    <b-modal id="modalEditAccess" title="Zugriff bearbeiten" size="md" @ok="submitEditAccess" @hidden="resetEditAccess"
      ok-title="Speichern" cancel-title="Abbrechen" :ok-disabled="savingAccess">
      <form class="forms-sample" @submit.prevent>
        <p class="mb-3"><strong>{{ editForm.name }}</strong><br /><span class="text-muted">{{ editForm.email }}</span></p>
        <b-form-group label="Rolle / Zugriff" label-for="editPreset">
          <b-form-select v-model="editForm.preset" :options="presetOptions" id="editPreset"></b-form-select>
        </b-form-group>
        <b-form-group v-if="editForm.preset === 'custom'" label="Freigeschaltete Bereiche">
          <b-form-checkbox-group v-model="editForm.bereiche" :options="bereicheOptions" stacked></b-form-checkbox-group>
          <small class="text-muted">Controlling/Übersicht und Anwesenheit sind immer verfügbar.</small>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import {
  getTraeger,
  updateTraeger,
  getAvailableLocations,
  assignLocation,
  unassignLocation,
  inviteUser,
  resetUser,
  deactivateUser,
  setUserAccess,
} from "@/services/traeger.service";

// Rollen-Presets (Label -> gesendeter preset-Wert). VERBATIM Wire-Contract.
const PRESET_OPTIONS = [
  { value: "full_admin", text: "Voll-Admin" },
  { value: "hr", text: "Personal / HR" },
  { value: "paedagogik", text: "Pädagogik / Betrieb" },
  { value: "controlling", text: "Controlling" },
  { value: "custom", text: "Benutzerdefiniert" },
];

// Schaltbare Bereiche (Label -> gesendeter Key). VERBATIM kanonische Bereichs-Keys.
const BEREICHE_OPTIONS = [
  { value: "personal", text: "Personal" },
  { value: "abwesenheiten", text: "Abwesenheiten" },
  { value: "zeiterfassung", text: "Zeiterfassung" },
  { value: "arbeitszeitkonto", text: "Arbeitszeitkonto" },
  { value: "dienstplan", text: "Dienstplan" },
  { value: "kinder", text: "Kinder" },
  { value: "familien", text: "Familien" },
  { value: "personalschluessel", text: "Personalschlüssel" },
];

// „Zuletzt angemeldet“ / „Zuletzt aktiv“ eines Zugangs: Datum mit Uhrzeit in Europe/Berlin
// („02.10.2026, 19:22“). Leer-/Gültig-Regel wie verwaltung src/utils/deptUserActivity.ts.
const USER_ACTIVITY_FORMAT = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

// Trefferliste im Zuordnungs-Picker; darüber hinaus wird zum Verfeinern aufgefordert.
const PICKER_MAX_VISIBLE = 50;

export default {
  name: "traeger-detail",
  data() {
    return {
      loading: true,
      saving_base: false,
      assigning: false,
      inviting: false,
      savingAccess: false,
      traeger: {},
      assignedLocations: [],
      users: [],
      availableLocations: [],
      selectedLocationUid: null,
      locationSearch: "",
      pickerOpen: false,
      onlyFree: false,
      highlightIndex: 0,
      presetOptions: PRESET_OPTIONS,
      bereicheOptions: BEREICHE_OPTIONS,
      inviteForm: { name: "", email: "", preset: "full_admin", bereiche: [] },
      editForm: { user_uid: null, name: "", email: "", preset: "full_admin", bereiche: [] },
    };
  },
  computed: {
    // Pool: alle Locations außer den bereits diesem Träger zugeordneten.
    // Locations, die bereits einem ANDEREN Träger gehören, bleiben wählbar und
    // lösen beim Zuordnen den Umhäng-Konflikt aus (foreign_department markiert sie).
    pickableLocations: function () {
      const assignedUids = {};
      for (let i = 0; i < this.assignedLocations.length; i++) {
        const loc = this.assignedLocations[i];
        assignedUids[loc.location_uid || loc.uid] = true;
      }
      const list = [];
      for (let k = 0; k < this.availableLocations.length; k++) {
        const loc = this.availableLocations[k];
        const uid = loc.location_uid || loc.uid;
        if (!uid || assignedUids[uid]) continue;
        list.push({
          uid: uid,
          name: loc.name || "",
          kindy_id: loc.kindy_id || "",
          address: loc.address || "",
          category: loc.category || "",
          current_department_uid: loc.current_department_uid || null,
          current_department_name: loc.current_department_name || "",
          foreign_department: !!(loc.current_department_uid && loc.current_department_uid !== this.traeger.uid),
        });
      }
      return list.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    },
    // Suche über Name, Kindy-ID, Adresse und Kategorie; alle Wortteile müssen treffen,
    // damit "sonne halle" auch die Kita "Sonnenschein" in Halle findet.
    filteredLocations: function () {
      let list = this.pickableLocations;
      if (this.onlyFree) {
        list = list.filter((loc) => !loc.current_department_uid);
      }
      const terms = (this.locationSearch || "")
        .toString()
        .toLowerCase()
        .split(/\s+/)
        .filter((t) => t.length > 0);
      if (terms.length === 0) return list;
      return list.filter((loc) => {
        const haystack = (loc.name + " " + loc.kindy_id + " " + loc.address + " " + loc.category).toLowerCase();
        return terms.every((t) => haystack.indexOf(t) !== -1);
      });
    },
    // Anzeige gedeckelt, damit die Liste bei ~500 Kitas nicht das Panel sprengt.
    visibleLocations: function () {
      return this.filteredLocations.slice(0, PICKER_MAX_VISIBLE);
    },
    selectedLocation: function () {
      if (!this.selectedLocationUid) return null;
      return this.pickableLocations.find((loc) => loc.uid === this.selectedLocationUid) || null;
    },
  },
  methods: {
    openPicker: function () {
      this.pickerOpen = true;
      this.highlightIndex = 0;
    },
    closePicker: function () {
      this.pickerOpen = false;
    },
    // Tippen verwirft eine bestehende Auswahl — sonst würde der Button eine Kita
    // zuordnen, die im Suchfeld gar nicht mehr steht.
    onSearchInput: function () {
      this.selectedLocationUid = null;
      this.pickerOpen = true;
      this.highlightIndex = 0;
    },
    moveHighlight: function (step) {
      if (!this.pickerOpen) {
        this.openPicker();
        return;
      }
      const count = this.visibleLocations.length;
      if (count === 0) return;
      let next = this.highlightIndex + step;
      if (next < 0) next = count - 1;
      if (next > count - 1) next = 0;
      this.highlightIndex = next;
    },
    chooseHighlighted: function () {
      if (!this.pickerOpen) return;
      const loc = this.visibleLocations[this.highlightIndex];
      if (loc) this.choose(loc);
    },
    choose: function (loc) {
      this.selectedLocationUid = loc.uid;
      this.locationSearch = loc.name;
      this.pickerOpen = false;
    },
    clearSelection: function () {
      this.selectedLocationUid = null;
      this.locationSearch = "";
      this.highlightIndex = 0;
      this.pickerOpen = false;
    },
    onDocumentMousedown: function (ev) {
      if (!this.pickerOpen) return;
      const picker = this.$refs.picker;
      if (picker && picker.contains(ev.target)) return;
      this.pickerOpen = false;
    },
    // Formatierter Zeitpunkt, oder null für alles, was kein nicht-leerer, parsbarer
    // String ist; dann zeigt die Zelle den Leertext.
    formatUserActivity: function (value) {
      if (typeof value !== "string" || value.trim() === "") return null;
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return null;
      return USER_ACTIVITY_FORMAT.format(date);
    },
    statusLabel: function (user) {
      if (user.status) return user.status === "active" ? "Aktiv" : user.status === "invited" ? "Eingeladen" : user.status;
      if (user.activated === true) return "Aktiv";
      return "Eingeladen";
    },
    statusClass: function (user) {
      const active = user.status === "active" || user.activated === true;
      return active ? "badge-success" : "badge-warning";
    },
    // Fehlendes preset-Feld => Bestandszugang = Voll-Admin (Migration A4).
    userPreset: function (user) {
      return (user && user.preset) || "full_admin";
    },
    presetLabel: function (preset) {
      const key = preset || "full_admin";
      const opt = PRESET_OPTIONS.find((o) => o.value === key);
      return opt ? opt.text : key;
    },
    bereichLabel: function (key) {
      const opt = BEREICHE_OPTIONS.find((o) => o.value === key);
      return opt ? opt.text : key;
    },
    load: function () {
      this.loading = true;
      getTraeger(this.$route.params.uid)
        .then((resp) => {
          const d = resp.data || {};
          this.traeger = d.traeger || d.department || {};
          this.assignedLocations = d.locations || [];
          this.users = d.users || [];
          return getAvailableLocations();
        })
        .then((resp) => {
          this.availableLocations = (resp.data && (resp.data.locations || resp.data)) || [];
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err && err.data && err.data.error === "user") {
            localStorage.removeItem("token");
            this.$router.push({ name: "login" });
            return;
          }
          if (err && err.data && err.data.error === "traeger") {
            this.$router.push({ name: "traeger" });
            return;
          }
          Vue.$toast.open({
            message: (err && err.message) || "Träger konnte nicht geladen werden",
            type: "error",
            position: "bottom",
            duration: 2800,
          });
        });
    },
    btnSaveBase: function (ev) {
      ev.preventDefault();
      this.saving_base = true;
      updateTraeger({
        uid: this.traeger.uid,
        name: this.traeger.name,
        street: this.traeger.street,
        zip: this.traeger.zip,
        city: this.traeger.city,
        email: this.traeger.email,
      })
        .then(() => {
          this.saving_base = false;
          Vue.$toast.open({ message: "Gespeichert", type: "success", position: "bottom", duration: 1500 });
        })
        .catch((err) => {
          this.saving_base = false;
          Vue.$toast.open({
            message: (err && err.message) || "Speichern fehlgeschlagen",
            type: "error",
            position: "bottom",
            duration: 2800,
          });
        });
    },
    assign: function (confirmReassign) {
      if (!this.selectedLocationUid) return;
      this.assigning = true;
      const payload = {
        department_uid: this.traeger.uid,
        location_uid: this.selectedLocationUid,
      };
      if (confirmReassign === true) {
        payload.confirm_reassign = true;
      }
      assignLocation(payload)
        .then(() => {
          this.assigning = false;
          this.clearSelection();
          Vue.$toast.open({ message: "Kita zugeordnet", type: "success", position: "bottom", duration: 1500 });
          this.load();
        })
        .catch((err) => {
          this.assigning = false;
          // Exklusivitäts-Konflikt: Backend liefert status:"error" + conflict-Objekt.
          if (err && err.conflict) {
            const from = err.conflict.current_department_name || "einem anderen Träger";
            this.$swal({
              title: "Kita umhängen?",
              text: "Diese Kita ist aktuell " + from + " zugeordnet. Von " + from + " zu " + (this.traeger.name || "diesem Träger") + " umhängen?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#2563eb",
              cancelButtonColor: "#64748b",
              cancelButtonText: "Abbrechen",
              confirmButtonText: "Ja, umhängen",
            }).then((result) => {
              if (result.value) {
                this.assign(true);
              }
            });
            return;
          }
          Vue.$toast.open({
            message: (err && err.message) || "Kita konnte nicht zugeordnet werden",
            type: "error",
            position: "bottom",
            duration: 2800,
          });
        });
    },
    unassign: function (loc) {
      this.$swal({
        title: "Kita entfernen?",
        text: 'Soll "' + loc.name + '" von diesem Träger entfernt werden?',
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#c53030",
        cancelButtonColor: "#64748b",
        cancelButtonText: "Abbrechen",
        confirmButtonText: "Ja, entfernen",
      }).then((result) => {
        if (!result.value) return;
        unassignLocation({
          department_uid: this.traeger.uid,
          location_uid: loc.location_uid || loc.uid,
        })
          .then(() => {
            Vue.$toast.open({ message: "Kita entfernt", type: "success", position: "bottom", duration: 1500 });
            this.load();
          })
          .catch((err) => {
            Vue.$toast.open({
              message: (err && err.message) || "Kita konnte nicht entfernt werden",
              type: "error",
              position: "bottom",
              duration: 2800,
            });
          });
      });
    },
    openInvite: function () {
      this.inviteForm = { name: "", email: "", preset: "full_admin", bereiche: [] };
      this.$bvModal.show("modalInviteUser");
    },
    resetInvite: function () {
      this.inviteForm = { name: "", email: "", preset: "full_admin", bereiche: [] };
    },
    submitInvite: function (bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.inviteForm.email || !this.inviteForm.email.trim()) {
        Vue.$toast.open({ message: "E-Mail ist erforderlich", type: "error", position: "bottom", duration: 2500 });
        return;
      }
      // Wire-Contract: {department_uid, name, email, preset, bereiche?} — bereiche NUR bei custom.
      const payload = {
        department_uid: this.traeger.uid,
        name: this.inviteForm.name,
        email: this.inviteForm.email,
        preset: this.inviteForm.preset,
      };
      if (this.inviteForm.preset === "custom") {
        payload.bereiche = this.inviteForm.bereiche || [];
      }
      this.inviting = true;
      inviteUser(payload)
        .then(() => {
          this.inviting = false;
          this.$bvModal.hide("modalInviteUser");
          Vue.$toast.open({ message: "Einladung versendet", type: "success", position: "bottom", duration: 1800 });
          this.load();
        })
        .catch((err) => {
          this.inviting = false;
          Vue.$toast.open({
            message: (err && err.message) || "Einladung konnte nicht versendet werden",
            type: "error",
            position: "bottom",
            duration: 2800,
          });
        });
    },
    openEditAccess: function (user) {
      const preset = this.userPreset(user);
      this.editForm = {
        user_uid: user.uid,
        name: user.name,
        email: user.email,
        preset: preset,
        bereiche: preset === "custom" ? (user.bereiche || []).slice() : [],
      };
      this.$bvModal.show("modalEditAccess");
    },
    resetEditAccess: function () {
      this.editForm = { user_uid: null, name: "", email: "", preset: "full_admin", bereiche: [] };
    },
    submitEditAccess: function (bvModalEvt) {
      bvModalEvt.preventDefault();
      // KRITISCH (fail-closed Backend): access-set MUSS immer ein gültiges preset senden.
      // Wire-Contract: {department_uid, user_uid, preset (PFLICHT), bereiche?} — bereiche NUR bei custom.
      const payload = {
        department_uid: this.traeger.uid,
        user_uid: this.editForm.user_uid,
        preset: this.editForm.preset,
      };
      if (this.editForm.preset === "custom") {
        payload.bereiche = this.editForm.bereiche || [];
      }
      this.savingAccess = true;
      setUserAccess(payload)
        .then(() => {
          this.savingAccess = false;
          this.$bvModal.hide("modalEditAccess");
          Vue.$toast.open({ message: "Zugriff gespeichert", type: "success", position: "bottom", duration: 1800 });
          this.load();
        })
        .catch((err) => {
          this.savingAccess = false;
          // Last-Full-Admin-Guard: Backend liefert status:"error" (code:"last_full_admin") mit Begründung.
          Vue.$toast.open({
            message: (err && err.message) || "Zugriff konnte nicht gespeichert werden",
            type: "error",
            position: "bottom",
            duration: 3200,
          });
        });
    },
    resetUserAccess: function (user) {
      resetUser({
        department_uid: this.traeger.uid,
        user_uid: user.uid,
      })
        .then(() => {
          Vue.$toast.open({ message: "Zugangsdaten zurückgesetzt, Mail versendet", type: "success", position: "bottom", duration: 2000 });
          this.load();
        })
        .catch((err) => {
          Vue.$toast.open({
            message: (err && err.message) || "Zurücksetzen fehlgeschlagen",
            type: "error",
            position: "bottom",
            duration: 2800,
          });
        });
    },
    deactivate: function (user) {
      this.$swal({
        title: "Zugang deaktivieren?",
        text: "Der Zugang wird deaktiviert.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#c53030",
        cancelButtonColor: "#64748b",
        cancelButtonText: "Abbrechen",
        confirmButtonText: "Ja, deaktivieren",
      }).then((result) => {
        if (!result.value) return;
        deactivateUser({
          department_uid: this.traeger.uid,
          user_uid: user.uid,
        })
          .then(() => {
            Vue.$toast.open({ message: "Zugang deaktiviert", type: "success", position: "bottom", duration: 1500 });
            this.load();
          })
          .catch((err) => {
            // Last-Full-Admin-Guard: Backend liefert status:"error" mit Begründung.
            Vue.$toast.open({
              message: (err && err.message) || "Zugang konnte nicht deaktiviert werden",
              type: "error",
              position: "bottom",
              duration: 3200,
            });
          });
      });
    },
  },
  mounted() {
    this.load();
    document.addEventListener("mousedown", this.onDocumentMousedown);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onDocumentMousedown);
  },
};
</script>

<style scoped>
.assign-row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  max-width: 640px;
}

.assign-picker {
  position: relative;
  flex: 1 1 auto;
}

.picker-input-wrap {
  position: relative;
}

.picker-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9c9fa6;
  font-size: 18px;
  pointer-events: none;
}

.picker-input {
  padding-left: 36px;
  padding-right: 34px;
}

.picker-clear {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #9c9fa6;
  line-height: 1;
  padding: 4px 6px;
  cursor: pointer;
}

.picker-clear:hover {
  color: #55595e;
}

.picker-panel {
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  background: #ffffff;
  border: 1px solid #e4e5ec;
  border-radius: 4px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.picker-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  font-size: 11px;
  color: #9c9fa6;
  border-bottom: 1px solid #f0f1f4;
}

.picker-toggle {
  margin: 0;
  cursor: pointer;
  user-select: none;
}

.picker-toggle input {
  margin-right: 4px;
  vertical-align: middle;
}

.picker-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 320px;
  overflow-y: auto;
}

.picker-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f6f7f9;
}

.picker-item.is-active {
  background-color: #f2f8ff;
}

.picker-item-main {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.picker-item-name {
  color: #3e4b5b;
  font-weight: 500;
}

.picker-item-id,
.picker-item-cat,
.assign-selected-id,
.assign-selected-cat {
  font-size: 11px;
  border-radius: 10px;
  padding: 1px 8px;
}

.picker-item-id,
.assign-selected-id {
  color: #1d4ed8;
  background-color: #eff6ff;
}

/* Kategorie neutral grau, damit sie sich von der blauen Kindy-ID absetzt */
.picker-item-cat,
.assign-selected-cat {
  color: #55595e;
  background-color: #eef0f3;
}

.picker-item-sub {
  font-size: 11px;
  color: #9c9fa6;
  margin-top: 2px;
}

.picker-item-owner {
  margin-left: 8px;
  color: #b45309;
}

.picker-empty,
.picker-more {
  padding: 12px;
  font-size: 12px;
  color: #9c9fa6;
  text-align: center;
}

.assign-selected {
  margin-top: 8px;
  font-size: 12px;
  color: #55595e;
  max-width: 640px;
}

.assign-selected-id,
.assign-selected-cat {
  margin-left: 6px;
}

.assign-selected-warn {
  display: block;
  margin-top: 2px;
  color: #b45309;
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.preset-badge {
  background-color: #eff6ff;
  color: #1d4ed8;
}

.bereich-chip {
  display: inline-block;
  margin: 2px 2px 2px 4px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  background-color: #f0f1f4;
  color: #55595e;
}

.bereich-chip-empty {
  background-color: transparent;
  color: #9c9fa6;
  font-style: italic;
}

.empty-state {
  text-align: center;
  padding: 30px 0;
  color: #9c9fa6;
}
</style>
